module.exports = __webpack_public_path__ + "static/media/reencoding_shutterstock_videos_x1.63f95850.mp4";